module.exports = __webpack_public_path__ + "img/company_logo_long.da8aa97e.png";